import ResizableTable from "../../../Components/ResizableTable/ResizableTable";
import { PageHeader } from "@ant-design/pro-components";
import { SolutionOutlined } from "@ant-design/icons";
import { Card, Empty, Input, Tag, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../api/api";

const PAGE_SIZE = 20;

const FormResponses = () => {
  const { key } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    setLoading(true);
    api
      .get(`/forms/${key}/responses`, {
        params: { page, pageSize: PAGE_SIZE, search },
      })
      .then((res) => setData(res.data))
      .catch(() => message.error("خطا در دریافت پاسخ‌ها"))
      .finally(() => setLoading(false));
  }, [key, page, search]);

  const responses = (data?.responses || []).map((r, i) => ({
    ...r,
    _key: (page - 1) * PAGE_SIZE + i,
  }));

  const columns = [
    {
      title: "ردیف",
      dataIndex: "_key",
      width: 70,
      align: "center",
      render: (v) => v + 1,
    },
    {
      title: "پاسخ‌دهنده",
      dataIndex: "respondent",
      render: (respondent) =>
        respondent?.type === "user" ? (
          <span>
            <Tag color="blue">کاربر</Tag>
            {respondent.name}{" "}
            <span style={{ color: "#999" }}>({respondent.phone})</span>
          </span>
        ) : (
          <span>
            <Tag>مهمان</Tag>
            <span style={{ color: "#999" }}>
              {respondent?.session?.slice(0, 8) || "-"}
            </span>
          </span>
        ),
    },
    {
      title: "زمان ثبت",
      dataIndex: "submittedAt",
      width: 200,
      render: (t) => (t ? new Date(t).toLocaleString("fa-IR") : "-"),
    },
  ];

  return (
    <div style={{ padding: "1rem" }}>
      <PageHeader
        title={`پاسخ‌های فرم: ${data?.formTitle || key}`}
        avatar={{ icon: <SolutionOutlined /> }}
        subTitle={`${data?.count || 0} پاسخ`}
      />
      <Card style={{ margin: "0 1rem 1rem" }}>
        <Input.Search
          placeholder="جستجوی پاسخ‌دهنده (نام یا شماره)"
          allowClear
          enterButton="جستجو"
          defaultValue={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onSearch={(v) => {
            setPage(1);
            setSearch(v.trim());
          }}
          style={{ maxWidth: 420 }}
        />
      </Card>
      <Card bodyStyle={{ padding: 0 }} style={{ margin: "0 1rem" }}>
        {!loading && responses.length === 0 ? (
          <Empty
            description={search ? "نتیجه‌ای یافت نشد" : "هنوز پاسخی ثبت نشده"}
            style={{ padding: "3rem 0" }}
          />
        ) : (
          <ResizableTable
            tableKey="form-responses"
            rowKey="_key"
            loading={loading}
            columns={columns}
            dataSource={responses}
            pagination={{
              current: page,
              pageSize: PAGE_SIZE,
              total: data?.count || 0,
              showSizeChanger: false,
              onChange: (p) => setPage(p),
            }}
            expandable={{
              expandedRowRender: (record) => (
                <ResizableTable
                  tableKey="form-response-answers"
                  size="small"
                  pagination={false}
                  rowKey={(row, idx) => idx}
                  dataSource={record.answers || []}
                  columns={[
                    { title: "سوال", dataIndex: "question", width: "45%" },
                    { title: "پاسخ", dataIndex: "value" },
                  ]}
                />
              ),
            }}
          />
        )}
      </Card>
    </div>
  );
};

export default FormResponses;
